import { ThemeProvider } from '@emotion/react';
import React from 'react';
import { Provider } from 'react-redux';
import LoadingModal from 'src/components/loading/LoadingModal';
import ErrorBoundary from 'src/config/ErrorBoundary';
import appTheme from 'src/styles/theme';

import { initSDKService } from './src/config/apiClient';

const MainApp = ({ reduxStore, children }) => {
  initSDKService();

  return (
    <ErrorBoundary>
      <Provider store={reduxStore}>
        <ThemeProvider theme={appTheme}>
          {children}
          <LoadingModal />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>
  );
};

export default MainApp;
